var map = {
	"./_.json": 206,
	"./en.json": 561,
	"./nl.json": 562
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 560;


//////////////////
// WEBPACK FOOTER
// ./src/assets/translations ^\.\/.*\.json$
// module id = 560
// module chunks = 14